import React, { Fragment }  from 'react';
import { Row, Col }  from 'react-bootstrap';
import FormLogin from '../../../components/auth/login'
import '../../../styles/login.scss';
import Head from '../../../components/head'


function LoginScreen () {
    return (
        <Fragment>
            <Head titulo="Login Fiscal da Transparência"/>
            <div className='bg-login'>
            <Row className="justify-content-md-center">
                <Col lg={4}>
                    <FormLogin />
                </Col>
            </Row>
            </div>
        </Fragment>
    );
}

export default LoginScreen;